// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".\\+KSJPa4kqkkzJ- label {\n  line-height: 20px;\n  margin-bottom: 4px;\n  color: var(--ds-text-subtle, #5e6c84);\n}\n.\\+KSJPa4kqkkzJ- button {\n  color: var(--ds-text-subtle, #5e6c84);\n  justify-content: space-between;\n  align-items: center;\n  text-align: left;\n}\n.\\+KSJPa4kqkkzJ- button .WsEvyPATE6T6sG {\n  display: flex;\n  align-items: center;\n  flex: 1;\n}\n.\\+KSJPa4kqkkzJ- button .WsEvyPATE6T6sG > span:first-child {\n  margin-right: 4px;\n}\n.\\+KSJPa4kqkkzJ- p {\n  font-size: 12px;\n  line-height: 16px;\n  color: var(--ds-text-subtle, #5e6c84);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"createTeamVisibility": "+KSJPa4kqkkzJ-",
	"selectText": "WsEvyPATE6T6sG"
};
export default ___CSS_LOADER_EXPORT___;
